import React from 'react';
import AppLogo from '@/components/ui/AppLogo';
import { Zap, Shield, Clock } from 'lucide-react';

const valueProps = [
  { icon: <Zap size={16} className="text-amber-400" />, text: 'AI scores every lead by budget & urgency — instantly' },
  { icon: <Clock size={16} className="text-blue-400" />, text: 'Photo-based estimates in seconds, not hours' },
  { icon: <Shield size={16} className="text-emerald-400" />, text: 'Stop chasing tire-kickers. Close high-leverage jobs' },
];

export default function AuthBrandPanel() {
  return (
    <div className="lg:w-[480px] xl:w-[520px] bg-[#0D0D0D] border-b lg:border-b-0 lg:border-r border-[#1A1A1A] flex flex-col justify-between px-8 py-10 lg:py-16 relative overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-600/8 via-transparent to-amber-500/5 pointer-events-none" />
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-600 via-blue-500 to-amber-500" />
      {/* Logo */}
      <div className="relative">
        <div className="flex items-center gap-3 mb-10 lg:mb-16">
          <AppLogo size={48} />
        </div>

        <h1 className="text-3xl lg:text-4xl font-800 text-white leading-tight mb-4 text-balance">
          Filter the tire-kickers.<br />
          <span className="text-blue-400">Close the real jobs.</span>
        </h1>
        <p className="text-[#666] text-base leading-relaxed mb-8 lg:mb-10">
          Every lead scored by AI the moment they submit. You only spend time on clients who are serious.
        </p>

        <ul className="space-y-4">
          {valueProps?.map(({ icon, text }, i) => (
            <li key={`vp-${i}`} className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-lg bg-[#1A1A1A] border border-[#2A2A2A] flex items-center justify-center flex-shrink-0">
                {icon}
              </div>
              <span className="text-[#AAA] text-sm leading-relaxed">{text}</span>
            </li>
          ))}
        </ul>
      </div>
      {/* Social proof */}
      <div className="relative mt-10 lg:mt-0">
        <div className="p-4 bg-[#111] border border-[#1F1F1F] rounded-xl">
          <p className="text-[#888] text-sm italic leading-relaxed mb-3">
            &ldquo;I used to spend 2 hours a day calling back bad leads. Now I only call the high-leverage ones and I&apos;ve doubled my close rate in 6 weeks.&rdquo;
          </p>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-blue-600/20 flex items-center justify-center text-blue-400 font-700 text-xs">JW</div>
            <div>
              <p className="text-white text-xs font-600">Jordan Wells</p>
              <p className="text-[#555] text-[11px]">Austin Pro Painters · Pro Plan</p>
            </div>
          </div>
        </div>
        <p className="text-[11px] text-[#333] mt-4 text-center">Powered by Serious Leverage Inc.</p>
      </div>
    </div>
  );
}